export default "/images/be8e219f51e86571f12202b636e08169.avif";